<template>
  <layout :title="title">
    <div class="d-flex align-center" slot="add" v-if="!isDisputeLetters">
      <add-manual-dispute-letter
        @add="fetchFaxes(options)"
        v-if="hasEdit('send-faxes') && isSendFaxAdmin"
      />
      <div v-if="!isAffiliateAuth">
        <add-button class="ml-3" @click="$router.push({ name: 'send-letters' })"
          >Add Dispute Letter</add-button
        >
      </div>
    </div>
    <div
      class="d-flex align-center gap-3"
      slot="add"
      v-if="isDisputeLetters && hasEdit('send-faxes')"
    >
      <identity-theft-report-add-button v-if="isSendFaxAdmin" />
      <dispute-letter-add-button />
    </div>
    <dispute-letters-filter
      :headers="headers"
      :items="list"
      ref="filter"
      @onUpdate="fetchFaxes(options)"
      @onFilterApply="onFilterApply"
    />
    <dynamic-table-view
      ref="table"
      :show-select="hasEdit('send-faxes') || hasDelete('send-faxes')"
      :server-items-length="total"
      :headers="headers"
      @onPageChange="fetchFaxes"
      v-model="selected"
      :list="list"
    >
      <div slot="left" class="d-flex mt-2">
        <dispute-letter-bulk-sent-date-update
          :items="selected"
          v-if="hasPermission('send-faxes', 'edit')"
          @fetchFaxes="fetchFaxes(options)"
        />
        <error-button
          @click="deleteAllFax()"
          v-if="hasPermission('send-faxes', 'delete')"
          :disabled="!selected.length"
          tile
          >Delete</error-button
        >
      </div>
      <template v-slot:item.status="{ item, value }">
        <v-tooltip bottom :disabled="!isSendFaxAdmin || !getErrorMessage(item)">
          <template v-slot:activator="{ on, attrs }">
            <span
              class="font-weight-bold"
              v-bind="attrs"
              v-on="on"
              :class="getStatusColor(getStatus(item))"
              >{{
                (getStatus(item) || "").split(" ").join("&nbsp;&nbsp;")
              }}</span
            >
          </template>
          <span>{{ getErrorMessage(item) }}</span>
        </v-tooltip>
      </template>

      <template v-slot:item.customer_name="{ value, item }">
        <router-link
          class="text-decoration-none"
          :to="{ name: 'client-profile', params: { id: item.customer } }"
        >
          {{ value }}
        </router-link>
      </template>
      <template v-slot:item.template="{ value, item }">
        <v-tooltip bottom v-if="item.is_manual_fax != true">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" color="primary">
              <v-icon> mdi-information-outline </v-icon>
            </v-btn>
          </template>
          <span>{{ value }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.actions="{ item }">
        <dispute-letters-menu
          v-if="item.is_manual_fax != true"
          @showLoader="loading = true"
          @hideLoader="loading = false"
          :item="item"
          @fetchFaxes="fetchFaxes(options)"
        />
      </template>
    </dynamic-table-view>
  </layout>
</template>

<script>
import Layout from "@/components/ui/Layout.vue";
import DynamicTableView from "@/components/ui/DynamicTableView.vue";
import {getHeaders, getStartEndDate} from "@/assets/utils/common.utils";
import {mapDocs, transformDisputeLetters} from "@/assets/utils/doc.utils";
import {colFaxes, colFaxSchedules, colFaxTemplates, functions,} from "@/assets/utils/firebase.utils";
import {getCountFromServer, getDocs, orderBy, query, where,} from "firebase/firestore";
import DisputeLettersFilter from "@/components/disputeLetters/DisputeLettersFilter.vue";
import {computed} from "vue";
import {faxStatusColors} from "@/assets/constants/fax.constants";
import DisputeLettersMenu from "@/components/disputeLetters/DisputeLettersMenu.vue";
import DisputeLetterBulkSentDateUpdate from "@/components/disputeLetters/DisputeLetterBulkSentDateUpdate.vue";
import ErrorButton from "@/components/ui/buttons/ErrorButton.vue";
import {httpsCallable} from "firebase/functions";
import DisputeLetterAddButton from "@/components/disputeLetters/DisputeLetterAddButton.vue";
import IdentityTheftReportAddButton from "@/components/disputeLetters/IdentityTheftReportAddButton.vue";
import AddButton from "@/components/ui/buttons/AddButton.vue";
import AddManualDisputeLetter from "@/components/disputeLetters/AddManualDisputeLetter.vue";

export default {
  components: {
    Layout,
    DynamicTableView,
    DisputeLettersFilter,
    DisputeLettersMenu,
    DisputeLetterBulkSentDateUpdate,
    ErrorButton,
    DisputeLetterAddButton,
    IdentityTheftReportAddButton,
    AddButton,
    AddManualDisputeLetter,
  },
  data() {
    return {
      selected: [],
      options: {},
      form: {},
      total: 20,
      list: [],
      loading: false,
      isLoading: true,
      faxTemplates: [],
      faxSchedules: [],
    };
  },
  provide() {
    return {
      faxTemplates: computed(() => this.faxTemplates),
      faxSchedules: computed(() => this.faxSchedules),
      isDisputeLetters: computed(() => this.isDisputeLetters),
    };
  },
  computed: {
    title() {
      return this.isDisputeLetters
        ? "Dispute Letters"
        : `Dispute Letters (${this.currentClient.name})`;
    },
    isDisputeLetters() {
      return this.$route.name == "dispute-letters";
    },
    headers() {
      let doc = {
        status: "Status",
        customer_name: "Client",
        fax_title: "Title",
        template: "",
        created_at: "Sent Date",
        updated_at: "Updated Date",
        actions: "Actions",
      };
      let sortable = [
        // "status",
        // "customer_name",
        // "fax_title",
        // "template",
        // "schedule",
        "created_at",
        // "updated_at",
      ];

      return getHeaders(doc).map((i) => {
        i.sortable = sortable.indexOf(i.value) != -1;
        return i;
      });
    },
    query() {
      let sortDesc = this.options.sortDesc[0];
      let sortBy = this.options.sortBy[0];
      let { status, schedule, customer, template, search } = this.form;
      let { start, end } = getStartEndDate(this.form);
      let terms = [];
      if (search) terms.push(search.trim().toLowerCase());

      let queryList = [];

      if (start && end) {
        queryList.push(orderBy("created_at", sortDesc ? "desc" : "asc"));
        queryList.push(where("created_at", ">=", start));
        queryList.push(where("created_at", "<=", end));
      }
      if (status) {
        if (
          status == "COMPLETED" &&
          !this.isSendFaxAdmin &&
          !this.hasSendFaxStatus
        ) {
          queryList.push(
            where("status", "not-in", ["DRAFT", "SENDING", "SUCCESS", "FAILED"])
          );
        } else {
          queryList.push(where("status", "==", status));
        }
      }
      if (schedule) queryList.push(where("schedule", "==", schedule));
      if (!this.isDisputeLetters) {
        queryList.push(where("customer", "==", this.$route.params.id));
      } else {
        if (customer) queryList.push(where("customer", "==", customer));
      }
      if (template) queryList.push(where("template", "==", template));
      if (terms.length > 0) {
        queryList.push(where("_search", "array-contains-any", terms));
      }
      if (sortBy) {
        if (sortBy == "created_at") {
          if (!start) {
            queryList.push(orderBy(sortBy, sortDesc ? "desc" : "asc"));
          }
        } else {
          queryList.push(orderBy(sortBy, sortDesc ? "desc" : "asc"));
        }
      } else if (!start) {
        queryList.push(orderBy("created_at", "desc"));
      }

      return {
        countQuery: query(colFaxes, ...queryList),
        pageQuery: query(
          colFaxes,
          ...[...queryList, ...this.getPaginationQuery(this.options)]
        ),
      };
    },
  },
  methods: {
    deleteAllFax() {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure you want to delete all the selected letters?",
        onConfirm: async (dialogVM) => {
          try {
            let manageLetter = httpsCallable(functions, "manageLetter");
            await manageLetter({
              action: "delete",
              data: { ids: this.selected.map((i) => i.id) },
            });
            vm.fetchFaxes(vm.options);
            dialogVM.loading = false;
            dialogVM.dialog = false;
          } catch (error) {
            dialogVM.loading = false;
            dialogVM.dialog = false;
            vm.isLoading = false;
            vm.notifyError(error.message);
          }
        },
      });
    },
    getStatus({ status, fax_list }) {
      if (this.isAffiliateAuth) {
        const s = status || "";
        if (!s || s === "DRAFT" || s === "SENDING" ||
            s === "SUCCESS" || s === "COMPLETED" ||
            s === "FAILED" || s.startsWith("SENT TO")) {
          return "Draft";
        }
        return "Sent";
      }
      let completedStatus = this.$store.getters.deliveryMethods.map(
        (i) => i.id
      );
      if (completedStatus.length == 0) return "";
      let completed = null;
      if (fax_list) {
        completed = fax_list.find((i) => i.status == "COMPLETE");
      }
      if (this.isSendFaxAdmin || this.hasSendFaxStatus) {
        if (completedStatus.includes(status)) {
          let statusItem = [...this.$store.getters.deliveryMethods].find(
            (i) => i.id == status
          );
          return statusItem ? statusItem.name : "";
        }
        return status;
      }
      if (completedStatus.indexOf(status) != -1) return "COMPLETED";
      if (completed != null && status == "SENDING") return "COMPLETED";
      return status.indexOf("SENT TO") != -1 ? "COMPLETED" : status;
    },

    getErrorMessage({ status, error_message }) {
      return status == "FAILED" ? error_message : "";
    },

    onFilterApply(event) {
      this.form = event;
      let options = this.$refs.table.options;
      this.$refs.table.options = { ...options, page: 1 };
    },
    getStatusColor(val) {
      if (this.isAffiliateAuth) {
        return val === "Sent" ? "green--text" : "grey--text";
      }
      return faxStatusColors[val] || "blue--text";
    },

    async fetchFaxes(options) {
      const vm = this;
      try {
        if (vm.loading) return;
        vm.options = options;
        vm.loading = true;
        let page = vm.options.page;
        let { countQuery, pageQuery } = vm.query;
        if (page == 1) {
          vm.total = (await getCountFromServer(countQuery)).data().count;
        }
        let docs = (await getDocs(pageQuery)).docs;
        vm.firstVisible = docs[0];
        vm.lastVisible = docs[docs.length - 1];
        // Template/schedule names are resolved from the dropdown lists,
        // which load in parallel with the letters. Wait for them so the
        // list isn't mapped against empty lookups on first load.
        await vm.dropdownsLoaded;
        vm.list = mapDocs(docs).map((i) =>
          transformDisputeLetters(i, this.faxTemplates, this.faxSchedules)
        );
        vm.currentPage = page;
        vm.loading = false;
      } catch (error) {
        console.log(error);
        vm.handleError(error);
      }
    },
    async fetchDropdowns() {
      try {
        this.isLoading = true;
        let scheduleQuery = query(
          colFaxSchedules,
          orderBy("schedule_name", "asc")
        );
        let templateQuery = query(
          colFaxTemplates,
          orderBy("template_name", "asc")
        );
        this.faxSchedules = mapDocs((await getDocs(scheduleQuery)).docs);
        this.faxTemplates = mapDocs((await getDocs(templateQuery)).docs);
        this.faxSchedules.unshift({ schedule_name: "N/A", value: "" });
        this.isLoading = false;
      } catch (e) {
        this.handleError(e);
      }
    },
  },
  created() {
    // Non-reactive: a promise fetchFaxes awaits before mapping the list.
    this.dropdownsLoaded = this.isAffiliateAuth
      ? Promise.resolve()
      : this.fetchDropdowns();
  },
};
</script>
<style></style>
